import { FaUser } from "react-icons/fa";
import "./centralAssinante.css";
const CentralAssinante = () => {
  return (
    <section className="central-do-assinante">
      <div className="conteudo-central-assinante">
        <h1>Central do assinante</h1>
        <p>
          Descubra a praticidade da nossa Central do Assinante na GeraisNet!
          Através dela, você pode realizar diversas ações sem sair de casa.
          Pague seus boletos com facilidade, solicite assistência técnica{" "}
        </p>
        <div className="lista">
          <ul>
            <li>Pague Boletos</li>
            <li>solicitação de atendimentos</li>
          </ul>
        </div>
        <div className="butao-assinante">
          <a
            className="btn2 assinante"
            href="http://geraisnet.ispfycloud.com.br/"
            target="_blank"
          >
            <FaUser size={17} className="icon-home-page icon-assinante" />
            Central assinante
          </a>
        </div>
      </div>
      <div className="container-foto">
        <img className="meninaCentral" src="/images/menina.png" />
      </div>
    </section>
  );
};

export default CentralAssinante;
